import { createRouter, createWebHistory } from "vue-router";
import HomeView from "../views/HomeView.vue";
import AboutView from "../views/AboutView.vue";
import ServicesView from "../views/ServicesView.vue";
import ReviewsView from "../views/ReviewsView.vue";
import ContactView from "../views/ContactView.vue";

const routes = [
  {
    path: "/",
    name: "home",
    component: HomeView,
    meta: { title: "الإســلامـيـة | كهرباء، سباكة، خدمات منازل في دبي" },
  },
  {
    path: "/about",
    name: "about",
    component: AboutView,
    meta: { title: "عن الإســلامـيـة | خبرة احترافية في الكهرباء والسباكة" },
  },
  {
    path: "/services",
    name: "services",
    component: ServicesView,
    meta: { title: "خدمات الإســلامـيـة | كهرباء، سباكة، صيانة وتركيبات" },
  },
  {
    path: "/reviews",
    name: "reviews",
    component: ReviewsView,
    meta: { title: "أراء العملاء الإســلامـيـة | طلب خدمة كهرباء أو سباكة" },
  },
  {
    path: "/contact",
    name: "contact",
    component: ContactView,
    meta: { title: "اتصل بنا الإســلامـيـة | طلب خدمة كهرباء أو سباكة" },
  },
];

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes,
});
router.beforeEach((to, from, next) => {
  document.title = to.meta.title || "الإســلامـيـة";
  next();
});
export default router;
